export const countryList = [
  {
    code: "AF",
    label: "Afghanistan",
    value: "Afghanistan",
  },
  {
    code: "AX",
    label: "Åland Islands",
    value: "Åland Islands",
  },
  {
    code: "AL",
    label: "Albania",
    value: "Albania",
  },
  {
    code: "DZ",
    label: "Algeria",
    value: "Algeria",
  },
  {
    code: "AS",
    label: "American Samoa",
    value: "American Samoa",
  },
  {
    code: "AD",
    label: "Andorra",
    value: "Andorra",
  },
  {
    code: "AO",
    label: "Angola",
    value: "Angola",
  },
  {
    code: "AI",
    label: "Anguilla",
    value: "Anguilla",
  },
  {
    code: "AQ",
    label: "Antarctica",
    value: "Antarctica",
  },
  {
    code: "AG",
    label: "Antigua and Barbuda",
    value: "Antigua and Barbuda",
  },
  {
    code: "AR",
    label: "Argentina",
    value: "Argentina",
  },
  {
    code: "AM",
    label: "Armenia",
    value: "Armenia",
  },
  {
    code: "AW",
    label: "Aruba",
    value: "Aruba",
  },
  {
    code: "AU",
    label: "Australia",
    value: "Australia",
  },
  {
    code: "AT",
    label: "Austria",
    value: "Austria",
  },
  {
    code: "AZ",
    label: "Azerbaijan",
    value: "Azerbaijan",
  },
  {
    code: "BS",
    label: "Bahamas",
    value: "Bahamas",
  },
  {
    code: "BH",
    label: "Bahrain",
    value: "Bahrain",
  },
  {
    code: "BD",
    label: "Bangladesh",
    value: "Bangladesh",
  },
  {
    code: "BB",
    label: "Barbados",
    value: "Barbados",
  },
  {
    code: "BY",
    label: "Belarus",
    value: "Belarus",
  },
  {
    code: "BE",
    label: "Belgium",
    value: "Belgium",
  },
  {
    code: "BZ",
    label: "Belize",
    value: "Belize",
  },
  {
    code: "BJ",
    label: "Benin",
    value: "Benin",
  },
  {
    code: "BM",
    label: "Bermuda",
    value: "Bermuda",
  },
  {
    code: "BT",
    label: "Bhutan",
    value: "Bhutan",
  },
  {
    code: "BO",
    label: "Bolivia, Plurinational State of",
    value: "Bolivia, Plurinational State of",
  },
  {
    code: "BQ",
    label: "Bonaire, Sint Eustatius and Saba",
    value: "Bonaire, Sint Eustatius and Saba",
  },
  {
    code: "BA",
    label: "Bosnia and Herzegovina",
    value: "Bosnia and Herzegovina",
  },
  {
    code: "BW",
    label: "Botswana",
    value: "Botswana",
  },
  {
    code: "BV",
    label: "Bouvet Island",
    value: "Bouvet Island",
  },
  {
    code: "BR",
    label: "Brazil",
    value: "Brazil",
  },
  {
    code: "IO",
    label: "British Indian Ocean Territory",
    value: "British Indian Ocean Territory",
  },
  {
    code: "BN",
    label: "Brunei Darussalam",
    value: "Brunei Darussalam",
  },
  {
    code: "BG",
    label: "Bulgaria",
    value: "Bulgaria",
  },
  {
    code: "BF",
    label: "Burkina Faso",
    value: "Burkina Faso",
  },
  {
    code: "BI",
    label: "Burundi",
    value: "Burundi",
  },
  {
    code: "CV",
    label: "Cabo Verde",
    value: "Cabo Verde",
  },
  {
    code: "KH",
    label: "Cambodia",
    value: "Cambodia",
  },
  {
    code: "CM",
    label: "Cameroon",
    value: "Cameroon",
  },
  {
    code: "CA",
    label: "Canada",
    value: "Canada",
  },
  {
    code: "KY",
    label: "Cayman Islands",
    value: "Cayman Islands",
  },
  {
    code: "CF",
    label: "Central African Republic",
    value: "Central African Republic",
  },
  {
    code: "TD",
    label: "Chad",
    value: "Chad",
  },
  {
    code: "CL",
    label: "Chile",
    value: "Chile",
  },
  {
    code: "CN",
    label: "China",
    value: "China",
  },
  {
    code: "CX",
    label: "Christmas Island",
    value: "Christmas Island",
  },
  {
    code: "CC",
    label: "Cocos (Keeling) Islands",
    value: "Cocos (Keeling) Islands",
  },
  {
    code: "CO",
    label: "Colombia",
    value: "Colombia",
  },
  {
    code: "KM",
    label: "Comoros",
    value: "Comoros",
  },
  {
    code: "CG",
    label: "Congo",
    value: "Congo",
  },
  {
    code: "CD",
    label: "Congo, Democratic Republic of the",
    value: "Congo, Democratic Republic of the",
  },
  {
    code: "CK",
    label: "Cook Islands",
    value: "Cook Islands",
  },
  {
    code: "CR",
    label: "Costa Rica",
    value: "Costa Rica",
  },
  {
    code: "HR",
    label: "Croatia",
    value: "Croatia",
  },
  {
    code: "CU",
    label: "Cuba",
    value: "Cuba",
  },
  {
    code: "CW",
    label: "Curaçao",
    value: "Curaçao",
  },
  {
    code: "CY",
    label: "Cyprus",
    value: "Cyprus",
  },
  {
    code: "CZ",
    label: "Czechia",
    value: "Czechia",
  },
  {
    code: "CI",
    label: "Côte d'Ivoire",
    value: "Côte d'Ivoire",
  },
  {
    code: "DK",
    label: "Denmark",
    value: "Denmark",
  },
  {
    code: "DJ",
    label: "Djibouti",
    value: "Djibouti",
  },
  {
    code: "DM",
    label: "Dominica",
    value: "Dominica",
  },
  {
    code: "DO",
    label: "Dominican Republic",
    value: "Dominican Republic",
  },
  {
    code: "EC",
    label: "Ecuador",
    value: "Ecuador",
  },
  {
    code: "EG",
    label: "Egypt",
    value: "Egypt",
  },
  {
    code: "SV",
    label: "El Salvador",
    value: "El Salvador",
  },
  {
    code: "GQ",
    label: "Equatorial Guinea",
    value: "Equatorial Guinea",
  },
  {
    code: "ER",
    label: "Eritrea",
    value: "Eritrea",
  },
  {
    code: "EE",
    label: "Estonia",
    value: "Estonia",
  },
  {
    code: "SZ",
    label: "Eswatini",
    value: "Eswatini",
  },
  {
    code: "ET",
    label: "Ethiopia",
    value: "Ethiopia",
  },
  {
    code: "FK",
    label: "Falkland Islands (Malvinas)",
    value: "Falkland Islands (Malvinas)",
  },
  {
    code: "FO",
    label: "Faroe Islands",
    value: "Faroe Islands",
  },
  {
    code: "FJ",
    label: "Fiji",
    value: "Fiji",
  },
  {
    code: "FI",
    label: "Finland",
    value: "Finland",
  },
  {
    code: "FR",
    label: "France",
    value: "France",
  },
  {
    code: "GF",
    label: "French Guiana",
    value: "French Guiana",
  },
  {
    code: "PF",
    label: "French Polynesia",
    value: "French Polynesia",
  },
  {
    code: "TF",
    label: "French Southern Territories",
    value: "French Southern Territories",
  },
  {
    code: "GA",
    label: "Gabon",
    value: "Gabon",
  },
  {
    code: "GM",
    label: "Gambia",
    value: "Gambia",
  },
  {
    code: "GE",
    label: "Georgia",
    value: "Georgia",
  },
  {
    code: "DE",
    label: "Germany",
    value: "Germany",
  },
  {
    code: "GH",
    label: "Ghana",
    value: "Ghana",
  },
  {
    code: "GI",
    label: "Gibraltar",
    value: "Gibraltar",
  },
  {
    code: "GR",
    label: "Greece",
    value: "Greece",
  },
  {
    code: "GL",
    label: "Greenland",
    value: "Greenland",
  },
  {
    code: "GD",
    label: "Grenada",
    value: "Grenada",
  },
  {
    code: "GP",
    label: "Guadeloupe",
    value: "Guadeloupe",
  },
  {
    code: "GU",
    label: "Guam",
    value: "Guam",
  },
  {
    code: "GT",
    label: "Guatemala",
    value: "Guatemala",
  },
  {
    code: "GG",
    label: "Guernsey",
    value: "Guernsey",
  },
  {
    code: "GN",
    label: "Guinea",
    value: "Guinea",
  },
  {
    code: "GW",
    label: "Guinea-Bissau",
    value: "Guinea-Bissau",
  },
  {
    code: "GY",
    label: "Guyana",
    value: "Guyana",
  },
  {
    code: "HT",
    label: "Haiti",
    value: "Haiti",
  },
  {
    code: "HM",
    label: "Heard Island and McDonald Islands",
    value: "Heard Island and McDonald Islands",
  },
  {
    code: "VA",
    label: "Holy See",
    value: "Holy See",
  },
  {
    code: "HN",
    label: "Honduras",
    value: "Honduras",
  },
  {
    code: "HK",
    label: "Hong Kong",
    value: "Hong Kong",
  },
  {
    code: "HU",
    label: "Hungary",
    value: "Hungary",
  },
  {
    code: "IS",
    label: "Iceland",
    value: "Iceland",
  },
  {
    code: "IN",
    label: "India",
    value: "India",
  },
  {
    code: "ID",
    label: "Indonesia",
    value: "Indonesia",
  },
  {
    code: "IR",
    label: "Iran, Islamic Republic of",
    value: "Iran, Islamic Republic of",
  },
  {
    code: "IQ",
    label: "Iraq",
    value: "Iraq",
  },
  {
    code: "IE",
    label: "Ireland",
    value: "Ireland",
  },
  {
    code: "IM",
    label: "Isle of Man",
    value: "Isle of Man",
  },
  {
    code: "IL",
    label: "Israel",
    value: "Israel",
  },
  {
    code: "IT",
    label: "Italy",
    value: "Italy",
  },
  {
    code: "JM",
    label: "Jamaica",
    value: "Jamaica",
  },
  {
    code: "JP",
    label: "Japan",
    value: "Japan",
  },
  {
    code: "JE",
    label: "Jersey",
    value: "Jersey",
  },
  {
    code: "JO",
    label: "Jordan",
    value: "Jordan",
  },
  {
    code: "KZ",
    label: "Kazakhstan",
    value: "Kazakhstan",
  },
  {
    code: "KE",
    label: "Kenya",
    value: "Kenya",
  },
  {
    code: "KI",
    label: "Kiribati",
    value: "Kiribati",
  },
  {
    code: "KP",
    label: "Korea, Democratic People's Republic of",
    value: "Korea, Democratic People's Republic of",
  },
  {
    code: "KR",
    label: "Korea, Republic of",
    value: "Korea, Republic of",
  },
  {
    code: "KW",
    label: "Kuwait",
    value: "Kuwait",
  },
  {
    code: "KG",
    label: "Kyrgyzstan",
    value: "Kyrgyzstan",
  },
  {
    code: "LA",
    label: "Lao People's Democratic Republic",
    value: "Lao People's Democratic Republic",
  },
  {
    code: "LV",
    label: "Latvia",
    value: "Latvia",
  },
  {
    code: "LB",
    label: "Lebanon",
    value: "Lebanon",
  },
  {
    code: "LS",
    label: "Lesotho",
    value: "Lesotho",
  },
  {
    code: "LR",
    label: "Liberia",
    value: "Liberia",
  },
  {
    code: "LY",
    label: "Libya",
    value: "Libya",
  },
  {
    code: "LI",
    label: "Liechtenstein",
    value: "Liechtenstein",
  },
  {
    code: "LT",
    label: "Lithuania",
    value: "Lithuania",
  },
  {
    code: "LU",
    label: "Luxembourg",
    value: "Luxembourg",
  },
  {
    code: "MO",
    label: "Macao",
    value: "Macao",
  },
  {
    code: "MG",
    label: "Madagascar",
    value: "Madagascar",
  },
  {
    code: "MW",
    label: "Malawi",
    value: "Malawi",
  },
  {
    code: "MY",
    label: "Malaysia",
    value: "Malaysia",
  },
  {
    code: "MV",
    label: "Maldives",
    value: "Maldives",
  },
  {
    code: "ML",
    label: "Mali",
    value: "Mali",
  },
  {
    code: "MT",
    label: "Malta",
    value: "Malta",
  },
  {
    code: "MH",
    label: "Marshall Islands",
    value: "Marshall Islands",
  },
  {
    code: "MQ",
    label: "Martinique",
    value: "Martinique",
  },
  {
    code: "MR",
    label: "Mauritania",
    value: "Mauritania",
  },
  {
    code: "MU",
    label: "Mauritius",
    value: "Mauritius",
  },
  {
    code: "YT",
    label: "Mayotte",
    value: "Mayotte",
  },
  {
    code: "MX",
    label: "Mexico",
    value: "Mexico",
  },
  {
    code: "FM",
    label: "Micronesia, Federated States of",
    value: "Micronesia, Federated States of",
  },
  {
    code: "MD",
    label: "Moldova, Republic of",
    value: "Moldova, Republic of",
  },
  {
    code: "MC",
    label: "Monaco",
    value: "Monaco",
  },
  {
    code: "MN",
    label: "Mongolia",
    value: "Mongolia",
  },
  {
    code: "ME",
    label: "Montenegro",
    value: "Montenegro",
  },
  {
    code: "MS",
    label: "Montserrat",
    value: "Montserrat",
  },
  {
    code: "MA",
    label: "Morocco",
    value: "Morocco",
  },
  {
    code: "MZ",
    label: "Mozambique",
    value: "Mozambique",
  },
  {
    code: "MM",
    label: "Myanmar",
    value: "Myanmar",
  },
  {
    code: "NA",
    label: "Namibia",
    value: "Namibia",
  },
  {
    code: "NR",
    label: "Nauru",
    value: "Nauru",
  },
  {
    code: "NP",
    label: "Nepal",
    value: "Nepal",
  },
  {
    code: "NL",
    label: "Netherlands",
    value: "Netherlands",
  },
  {
    code: "NC",
    label: "New Caledonia",
    value: "New Caledonia",
  },
  {
    code: "NZ",
    label: "New Zealand",
    value: "New Zealand",
  },
  {
    code: "NI",
    label: "Nicaragua",
    value: "Nicaragua",
  },
  {
    code: "NE",
    label: "Niger",
    value: "Niger",
  },
  {
    code: "NG",
    label: "Nigeria",
    value: "Nigeria",
  },
  {
    code: "NU",
    label: "Niue",
    value: "Niue",
  },
  {
    code: "NF",
    label: "Norfolk Island",
    value: "Norfolk Island",
  },
  {
    code: "MK",
    label: "North Macedonia",
    value: "North Macedonia",
  },
  {
    code: "MP",
    label: "Northern Mariana Islands",
    value: "Northern Mariana Islands",
  },
  {
    code: "NO",
    label: "Norway",
    value: "Norway",
  },
  {
    code: "OM",
    label: "Oman",
    value: "Oman",
  },
  {
    code: "PK",
    label: "Pakistan",
    value: "Pakistan",
  },
  {
    code: "PW",
    label: "Palau",
    value: "Palau",
  },
  {
    code: "PS",
    label: "Palestine, State of",
    value: "Palestine, State of",
  },
  {
    code: "PA",
    label: "Panama",
    value: "Panama",
  },
  {
    code: "PG",
    label: "Papua New Guinea",
    value: "Papua New Guinea",
  },
  {
    code: "PY",
    label: "Paraguay",
    value: "Paraguay",
  },
  {
    code: "PE",
    label: "Peru",
    value: "Peru",
  },
  {
    code: "PH",
    label: "Philippines",
    value: "Philippines",
  },
  {
    code: "PN",
    label: "Pitcairn",
    value: "Pitcairn",
  },
  {
    code: "PL",
    label: "Poland",
    value: "Poland",
  },
  {
    code: "PT",
    label: "Portugal",
    value: "Portugal",
  },
  {
    code: "PR",
    label: "Puerto Rico",
    value: "Puerto Rico",
  },
  {
    code: "QA",
    label: "Qatar",
    value: "Qatar",
  },
  {
    code: "RO",
    label: "Romania",
    value: "Romania",
  },
  {
    code: "RU",
    label: "Russian Federation",
    value: "Russian Federation",
  },
  {
    code: "RW",
    label: "Rwanda",
    value: "Rwanda",
  },
  {
    code: "RE",
    label: "Réunion",
    value: "Réunion",
  },
  {
    code: "BL",
    label: "Saint Barthélemy",
    value: "Saint Barthélemy",
  },
  {
    code: "SH",
    label: "Saint Helena, Ascension and Tristan da Cunha",
    value: "Saint Helena, Ascension and Tristan da Cunha",
  },
  {
    code: "KN",
    label: "Saint Kitts and Nevis",
    value: "Saint Kitts and Nevis",
  },
  {
    code: "LC",
    label: "Saint Lucia",
    value: "Saint Lucia",
  },
  {
    code: "MF",
    label: "Saint Martin (French part)",
    value: "Saint Martin (French part)",
  },
  {
    code: "PM",
    label: "Saint Pierre and Miquelon",
    value: "Saint Pierre and Miquelon",
  },
  {
    code: "VC",
    label: "Saint Vincent and the Grenadines",
    value: "Saint Vincent and the Grenadines",
  },
  {
    code: "WS",
    label: "Samoa",
    value: "Samoa",
  },
  {
    code: "SM",
    label: "San Marino",
    value: "San Marino",
  },
  {
    code: "ST",
    label: "Sao Tome and Principe",
    value: "Sao Tome and Principe",
  },
  {
    code: "SA",
    label: "Saudi Arabia",
    value: "Saudi Arabia",
  },
  {
    code: "SN",
    label: "Senegal",
    value: "Senegal",
  },
  {
    code: "RS",
    label: "Serbia",
    value: "Serbia",
  },
  {
    code: "SC",
    label: "Seychelles",
    value: "Seychelles",
  },
  {
    code: "SL",
    label: "Sierra Leone",
    value: "Sierra Leone",
  },
  {
    code: "SG",
    label: "Singapore",
    value: "Singapore",
  },
  {
    code: "SX",
    label: "Sint Maarten (Dutch part)",
    value: "Sint Maarten (Dutch part)",
  },
  {
    code: "SK",
    label: "Slovakia",
    value: "Slovakia",
  },
  {
    code: "SI",
    label: "Slovenia",
    value: "Slovenia",
  },
  {
    code: "SB",
    label: "Solomon Islands",
    value: "Solomon Islands",
  },
  {
    code: "SO",
    label: "Somalia",
    value: "Somalia",
  },
  {
    code: "ZA",
    label: "South Africa",
    value: "South Africa",
  },
  {
    code: "GS",
    label: "South Georgia and the South Sandwich Islands",
    value: "South Georgia and the South Sandwich Islands",
  },
  {
    code: "SS",
    label: "South Sudan",
    value: "South Sudan",
  },
  {
    code: "ES",
    label: "Spain",
    value: "Spain",
  },
  {
    code: "LK",
    label: "Sri Lanka",
    value: "Sri Lanka",
  },
  {
    code: "SD",
    label: "Sudan",
    value: "Sudan",
  },
  {
    code: "SR",
    label: "Suriname",
    value: "Suriname",
  },
  {
    code: "SJ",
    label: "Svalbard and Jan Mayen",
    value: "Svalbard and Jan Mayen",
  },
  {
    code: "SE",
    label: "Sweden",
    value: "Sweden",
  },
  {
    code: "CH",
    label: "Switzerland",
    value: "Switzerland",
  },
  {
    code: "SY",
    label: "Syrian Arab Republic",
    value: "Syrian Arab Republic",
  },
  {
    code: "TW",
    label: "Taiwan, Province of China",
    value: "Taiwan, Province of China",
  },
  {
    code: "TJ",
    label: "Tajikistan",
    value: "Tajikistan",
  },
  {
    code: "TZ",
    label: "Tanzania, United Republic of",
    value: "Tanzania, United Republic of",
  },
  {
    code: "TH",
    label: "Thailand",
    value: "Thailand",
  },
  {
    code: "TL",
    label: "Timor-Leste",
    value: "Timor-Leste",
  },
  {
    code: "TG",
    label: "Togo",
    value: "Togo",
  },
  {
    code: "TK",
    label: "Tokelau",
    value: "Tokelau",
  },
  {
    code: "TO",
    label: "Tonga",
    value: "Tonga",
  },
  {
    code: "TT",
    label: "Trinidad and Tobago",
    value: "Trinidad and Tobago",
  },
  {
    code: "TN",
    label: "Tunisia",
    value: "Tunisia",
  },
  {
    code: "TR",
    label: "Turkey",
    value: "Turkey",
  },
  {
    code: "TM",
    label: "Turkmenistan",
    value: "Turkmenistan",
  },
  {
    code: "TC",
    label: "Turks and Caicos Islands",
    value: "Turks and Caicos Islands",
  },
  {
    code: "TV",
    label: "Tuvalu",
    value: "Tuvalu",
  },
  {
    code: "UG",
    label: "Uganda",
    value: "Uganda",
  },
  {
    code: "UA",
    label: "Ukraine",
    value: "Ukraine",
  },
  {
    code: "AE",
    label: "United Arab Emirates",
    value: "United Arab Emirates",
  },
  {
    code: "GB",
    label: "United Kingdom",
    value: "United Kingdom",
  },
  {
    code: "UM",
    label: "United States Minor Outlying Islands",
    value: "United States Minor Outlying Islands",
  },
  {
    code: "US",
    label: "United States",
    value: "United States",
  },
  {
    code: "UY",
    label: "Uruguay",
    value: "Uruguay",
  },
  {
    code: "UZ",
    label: "Uzbekistan",
    value: "Uzbekistan",
  },
  {
    code: "VU",
    label: "Vanuatu",
    value: "Vanuatu",
  },
  {
    code: "VE",
    label: "Venezuela, Bolivarian Republic of",
    value: "Venezuela, Bolivarian Republic of",
  },
  {
    code: "VN",
    label: "Viet Nam",
    value: "Viet Nam",
  },
  {
    code: "VG",
    label: "Virgin Islands, British",
    value: "Virgin Islands, British",
  },
  {
    code: "VI",
    label: "Virgin Islands, U.S.",
    value: "Virgin Islands, U.S.",
  },
  {
    code: "WF",
    label: "Wallis and Futuna",
    value: "Wallis and Futuna",
  },
  {
    code: "EH",
    label: "Western Sahara",
    value: "Western Sahara",
  },
  {
    code: "YE",
    label: "Yemen",
    value: "Yemen",
  },
  {
    code: "ZM",
    label: "Zambia",
    value: "Zambia",
  },
  {
    code: "ZW",
    label: "Zimbabwe",
    value: "Zimbabwe",
  },
];
